// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CancelReason_titleContainer__31KrE","contentContainer":"CancelReason_contentContainer__3YrU2"};